export default function isSSML(text) {
    return !!text.match(/<speak>/);
}
